<div class="search">
	<pv-search placeholder="{{ 'general.search' | translate }}" (searchTerm)="search$.next($event)" />
</div>
<call-event-list scroll="callEventList" [callEvents]="callEvents$ | async" (selectedCallEvent)="details.emit($event)" />
